module.exports = "<span class=\"aTitle\">{{title}}</span><br />\n<ul>\n\t<li>New Sweatsuits (Tops &amp; Bottoms) </li>\n\t<li>Underwear (3-packs, Men&#39;s &amp; Women&#39;s) </li>\n\t<li>Black duffel bags </li>\n\t<li>Athletic Shoes (Men&#39;s &amp; Women&#39;s) </li>\n\t<li>Toiletries </li>\n\t<li>Fundries </li>\n\t<li>Winter Coats &amp; Gloves </li>\n\t<li>Phone Cards </li>\n\t<li>DVDs </li>\n\t<li>DVD Players </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/needs.component.html
// module id = 161
// module chunks = 1